import { Component, OnInit } from '@angular/core';
import { Fixtures } from '../fixtures';

@Component({
  selector: 'app-learn-structure',
  templateUrl: './learn-structure.component.html',
  styleUrls: ['./learn-structure.component.scss']
})
export class LearnStructureComponent implements OnInit {

  modules: any[];

  constructor(private entities: Fixtures) {}

  ngOnInit(): void {
    this.modules = this.entities.modules;
  }

}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/learn-structure/learn-structure.component.ts